import Box from "@mui/material/Box";

import DeleteAllowanceButton from "./DeleteAllowanceButton";

type AllowanceActionsProps = {
  allowanceId: string;
  refetchAllowance: () => void;
};

export default function AllowanceActions({
  allowanceId,
  refetchAllowance,
}: AllowanceActionsProps) {
  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}>
      <DeleteAllowanceButton
        allowanceId={allowanceId}
        refetchAllowance={refetchAllowance}
      />
    </Box>
  );
}
